import { translate } from 'loankeeper-common/helpers'

const formName = 'frm_collateral_view'

export const translateWebMessages = (name: string): string => translate(`frm_web_messages-${name}`)
export const transTab = (name: string): string => translate(formName, `tb_${name}`)
export const transLabel = (name: string): string => translate(formName, `lbl_${name}`)
export const transCommand = (name: string): string => translate(formName, `cmd_${name}`)
export const transTable = (_table: any, name: string): string => translate(formName, `dbgrd_${name}`)
export const translateLKMessage = (name: string): string => translate(`LKMESSAGE-${name}`)
export const translateCollateral = (name: string): string => translate(`frm_collateral_view-${name}`)

export const getWindowName = (data: { base: { FullName: string } }, ID: number) =>
  `${transLabel('coll_det_t')} ${data.base.FullName} (ID ${ID})`
export const getWindowShortName = (data: { base: { FullName: string } }) => `${data.base.FullName}`
export const getUri = (data: { base: { TypeID: number } }, ID: number, hash: string) =>
  `/secure/collateral/${ID}/details/${hash}/${data.base.TypeID}`

export const icon = (objectName: string) => `${formName}/${objectName}`
export const commonIcon = (objectName: string) => `common/${objectName}`
